import React from "react";
import { Link } from "react-router-dom";
import { getAllProjects } from "../../lib/loadContent";

const Projects = () => {
  const projects = getAllProjects();

  const ASCII = `
██████╗ ██████╗  ██████╗      ██╗███████╗ ██████╗████████╗███████╗
██╔══██╗██╔══██╗██╔═══██╗     ██║██╔════╝██╔════╝╚══██╔══╝██╔════╝
██████╔╝██████╔╝██║   ██║     ██║█████╗  ██║        ██║   ███████╗
██╔═══╝ ██╔══██╗██║   ██║██   ██║██╔══╝  ██║        ██║   ╚════██║
██║     ██║  ██║╚██████╔╝╚█████╔╝███████╗╚██████╗   ██║   ███████║
╚═╝     ╚═╝  ╚═╝ ╚═════╝  ╚════╝ ╚══════╝ ╚═════╝   ╚═╝   ╚══════╝`;

  return (
    <div className="page">
      <h1 className="ascii-logo">{ASCII}</h1>
      <p className="page-path">~/portfolio/projects/</p>

      <p>Some stuff that I have been working on for fun</p>

      <div className="project-grid">
        {projects.map((p) => (
          <Link
            to={`/projects/${p.slug}`}
            key={p.slug}
            className="project-card"
          >
            <h2 className="project-card-title">{p.title}</h2>
            <p className="project-card-desc">{p.description}</p>
            <div className="project-tags">
              {p.tags.map((t) => (
                <span key={t} className="tag">
                  {t}
                </span>
              ))}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Projects;
